<div class="mega-menu-container" (click)="$event.stopPropagation()">
  <button class="close-btn" (click)="close()">✕</button>

  <h2 class="mega-menu-title">Select AI Model</h2>

  <div #selectionBar class="selection-bar">
    <div class="selection-label">Selected:</div>
    <div class="selection-value">
      <span *ngIf="visibleSelectedModelName; else noneSelected">
        <span *ngIf="showCommandInstructSelectionLabel(); else catalogPlainSelectionName" class="command-instruct-display command-instruct-display--with-vendor" title="Cohere Command Instruct">
          <span class="command-instruct-vendor">Cohere</span>
          <span class="command-loop-symbol" aria-hidden="true">⌘</span>
          <span class="command-instruct-text">Instruct</span>
        </span>
        <ng-template #catalogPlainSelectionName>{{ visibleSelectedModelName }}</ng-template>
      </span>
      <ng-template #noneSelected>
        <span class="selection-muted">None</span>
      </ng-template>
    </div>

    <div class="selection-actions">
      <button
        class="apply-btn"
        type="button"
        (click)="apply()"
        *ngIf="selectedModel && !showPremiumForSelection() && !showComingSoonForSelection()">
        Apply
      </button>
      <a
        class="premium-btn coming-soon-anchor"
        href=""
        (click)="$event.preventDefault()"
        *ngIf="showComingSoonForSelection()">
        Coming Soon
      </a>
      <button
        class="premium-btn"
        type="button"
        (click)="onPremiumClick()"
        *ngIf="showPremiumForSelection() && !showComingSoonForSelection()">
        Log In
      </button>
    </div>
  </div>

  <div class="model-grid" role="list">
    <button
      class="model-button"
      type="button"
      role="listitem"
      *ngFor="let model of catalogModels"
      (click)="choose(model)"
      [class.selected]="isSelected(model)">
      <span *ngIf="isCommandLightCatalogModel(model)" class="model-name command-instruct-display" title="Command Instruct">
        <span class="command-loop-symbol" aria-hidden="true">⌘</span>
        <span class="command-instruct-text">Instruct</span>
      </span>
      <span *ngIf="!isCommandLightCatalogModel(model)" class="model-name">{{ getModelName(model) }}</span>
    </button>
  </div>

  <div class="model-bio-section" *ngIf="visibleSelectedModel as selected">
    <details class="model-bio-card" open>
      <summary>
        <span
          *ngIf="isCommandLightCatalogModel(selected); else catalogBioCohereRPlusName"
          class="model-bio-name command-instruct-display command-instruct-display--with-vendor"
          title="Cohere Command Instruct">
          <span class="command-instruct-vendor">Cohere</span>
          <span class="command-loop-symbol" aria-hidden="true">⌘</span>
          <span class="command-instruct-text">Instruct</span>
        </span>
        <ng-template #catalogBioCohereRPlusName>
          <span
            *ngIf="isCohereRPlusCatalogModel(selected); else catalogBioPlainName"
            class="model-bio-name command-instruct-display command-instruct-display--with-vendor"
            title="Cohere R+">
            <span class="command-instruct-vendor">Cohere</span>
            <span class="command-loop-symbol" aria-hidden="true">⌘</span>
            <span class="command-instruct-text">R+</span>
          </span>
        </ng-template>
        <ng-template #catalogBioPlainName>
          <span class="model-bio-name">{{ getModelName(selected) }}</span>
        </ng-template>
      </summary>
      <div class="model-bio-content">
        <div class="model-bio-image">
          <img [src]="getModelImage(selected)" [alt]="getModelName(selected) + ' logo'" />
        </div>
        <div class="model-bio-details">
          <p class="model-bio-summary">{{ getModelBio(selected).shortBio }}</p>
          <div class="model-bio-meta">
            <div *ngIf="selected.value === 'glm5'">
  <span class="meta-label">Series</span>GLM-5
</div>
            <div><span class="meta-label">Vendor</span>{{ getModelBio(selected).vendor }}</div>
          </div>
          <div class="model-bio-columns">
            <div>
              <h4>Strengths</h4>
              <ul>
                <li *ngFor="let strength of getModelBio(selected).strengths">{{ strength }}</li>
              </ul>
            </div>
            <div>
              <h4>Best for</h4>
              <ul>
                <li *ngFor="let best of getModelBio(selected).bestFor">{{ best }}</li>
              </ul>
            </div>
          </div>
          <p class="model-bio-full">{{ getModelBio(selected).bio }}</p>
        </div>
      </div>
    </details>
  </div>

  <div class="actions">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
  </div>
</div>